import produce from 'immer';
import orderBy from 'lodash/orderBy';
import { getSelected, getCount } from '@common/Filters/helpers/filterItemHelpers';
import sortByPropertyValue from '@helpers/sortByPropertyValue';

export const getFormattedSizeFilters = ({ dropdownFilters, availableFilters, activeFilters }) => dropdownFilters.size.groups
    .map(group => produce(group, (draftGroup) => {
        draftGroup.ranges = getSelected(
            getCount(draftGroup.ranges, availableFilters?.size),
            activeFilters
        )
            .sort(sortByPropertyValue('sortOrder'));
    }));

export const getFiltersByType = ({
    filterType, dropdownFilters, availableFilters, activeFilters
}) => {
    let filterItems = dropdownFilters[filterType];

    filterItems = getCount(filterItems, availableFilters?.[filterType]);
    filterItems = getSelected(filterItems, activeFilters);
    filterItems = orderBy(filterItems, ['name']);

    return filterItems;
};

export const getFormattedBrandFilters = ({
    activeBrandId, dropdownFilters, availableFilters, activeFilters
}) => {
    const brands = getCount(dropdownFilters.brand, availableFilters?.brand, activeBrandId);
    return getSelected(brands, activeFilters);
};
